// React
import React, { useEffect, useState } from 'react';
import 'react-tagsinput/react-tagsinput.css';

// Telegram UI
import { AppRoot, Cell, Checkbox, Section, Select, Radio } from '@telegram-apps/telegram-ui';

const tg = window.Telegram.WebApp;

const PostingPage = ({ activePanel, setActivePanel, userInfo, FaTelegram, baseTheme, avatarSrc, isMobile, setGptLink, setGptMedia, setGptText, selectedGroup, activeView, setActiveView, premodePosts }) => {
    const filteredPosts = premodePosts.filter(post => selectedGroup === null || post.id === selectedGroup.id);
    const [mode, setMode] = useState(selectedGroup.streams[0].premode);
    const [approve, setApprove] = useState(selectedGroup.streams[0].approve)
    const [premodeTime, setPremodeTime] = useState(selectedGroup.streams[0].premode_time);

    const notice_map = [
        { label: "10 минут", value: 10 },
        { label: "15 минут", value: 15 },
        { label: "30 минут", value: 30 },
        { label: "1 час", value: 60 },
        { label: "2 часа", value: 120 }
    ];

    useEffect(() => {
        const backButtonHandler = () => {
            tg.HapticFeedback.impactOccurred('heavy');
            tg.HapticFeedback.notificationOccurred("success");
            setActivePanel('channel');
        };

        if (activePanel === 'posting') {
            tg.BackButton.show();
            tg.BackButton.onClick(backButtonHandler);
        }

        return () => {
            tg.BackButton.offClick(backButtonHandler);
        };
    }, [activePanel]);

    useEffect(() => {
        const saveMode = async () => {
            const url = 'https://api.gmpapp.ru/save_mode';

            try {
                const response = await fetch(url, {
                    method: 'POST',
                    headers: { 'Content-Type': 'application/json' },
                    body: JSON.stringify({ mode: mode, premode_time: premodeTime, approve: approve, group_id: selectedGroup.id }),
                });

                if (!response.ok) {
                    // Здесь можно обрабатывать неуспешные коды ответов
                    console.error('Error:', response.status, response.statusText);
                } else {
                    // Если ответ успешен, можно сделать что-то с данными
                    const data = await response.json();
                    console.log('Success:', data);
                    
                    // Оптимистичное обновление
                    if (selectedGroup && selectedGroup.streams && selectedGroup.streams.length > 0) {
                        selectedGroup.streams[0].premode = mode;
                        selectedGroup.streams[0].approve = approve;
                        selectedGroup.streams[0].premode_time = premodeTime;
                    }
                }
            } catch (error) {
                console.error('Error mode sending', error);
            }
        };

        saveMode();
    }, [mode, premodeTime, approve]);

    const handleApproveChange = (event) => {
        setApprove(event.target.checked);
    };

    return (
        <div className="wrapperUI">
            <AppRoot platform='ios'>
                <Section className='sectionChannelMode' header="Режим работы">
                    <Cell Component="label" before={<Radio checked={!mode} onClick={() => setMode(false)} name="radio" value="1" />}
                        description="Сервис будет автоматически осуществлять публикации в ваш канал или группу в соответствии с заданными таймерами и днями недели"
                        multiline
                    >
                        Автопостинг
                    </Cell>
                    <Cell Component="label" before={<Radio checked={mode} onClick={() => setMode(true)} name="radio" value="2" />}
                        description="Наш бот будет отправлять вам посты на предварительную модерацию за указанное вами время, предоставляя возможность принять решение о публикации"
                        multiline
                    >
                        Премодерация
                    </Cell>
                </Section>
                {mode ? (
                    <Section className='sectionChannelMode' header="Параметры премодерации">
                        <Section className='sectionChannelModeNotice' header="Предупредить за">
                            <Select header="Select" placeholder="Предупредить за" onChange={(e) => { setPremodeTime(e.target.value); }} value={premodeTime} name="notice">
                                {notice_map.map((option) => (
                                    <option key={option.value} value={option.value}>
                                        {option.label}
                                    </option>
                                ))}
                            </Select>
                        </Section>
                        <Cell
                            Component="label"
                            before={<Checkbox onChange={handleApproveChange} defaultChecked={approve} name="checkbox" value="1" />}
                            description="Сервис сформирует пост и отправит вам через бота. Решение о публикации будете принимать вы"
                            multiline
                        >
                            Не публиковать без одобрения
                        </Cell>
                    </Section>
                ) : null}
            </AppRoot>
        </div>
    );
};

export default PostingPage;